<template>
    <div class="mt-3" v-if="selectProducts.length">
        <div class="panel-toolbar d-flex">
            <multiselect v-model="selectedProduct"
                        :options="selectProducts"
                        :close-on-select="false"
                        :hide-selected="true"
                        :preserve-search="true"
                        placeholder="Select Product"
                        label="getHTMLDescription"
                        multiple
                        track-by="id"
                        >
            </multiselect>
            <button class="btn btn-cph-primary ml-3" @click="addProductToShop" v-show="this.selectedProduct">Add product</button>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Multiselect from 'vue-multiselect';

export default {
    components: {
        Multiselect
    },
    data(){
        return {
            selectedProduct: []
        }
    },
    props: {
        shopProducts: {
            type: Array,
            default: []
        }
    },
    computed: {
        ...mapGetters({
            defaultProducts: 'getDefaultProducts'
        }),
        selectProducts: function selectData() {
            let allProductsIds = this.shopProducts.map(el => el.id)
            let defaultProductsIds = this.defaultProducts.map(el => el.id)
            let selectProductsIds = defaultProductsIds.filter(el => {
                return allProductsIds.indexOf(el) > -1 ?  false : true
            })
            let data = this.defaultProducts.filter(el => {
                return selectProductsIds.indexOf(el.id) > -1 ? true : false
            })
            return data;
        },
    },
    methods: {
        ...mapActions([
            'getProductDefaultListAsync',
        ]),
        ...mapMutations(['addAlert']),
        addProductToShop() {
            let context = window.localStorage.getItem('Store')
            let savingProducts = []

            this.selectedProduct.forEach(product => {
                product.isDefault = true;
                product.setContext(context);
                savingProducts.push(product.save().then((product) => {
                    this.shopProducts.unshift(product);
                }))
            })
            this.selectedProduct = [];
            Promise.all(savingProducts).then(() => {
                this.addAlert({
                    title: 'Created ',
                    type: 'success',
                    body: 'products have been saved at top of list'
                })
            })
        }
    },
    created () {
        this.getProductDefaultListAsync()
    }

}
</script>

<style lang="scss">
.d-flex {
    display: flex;
}

.panel-toolbar {
    justify-content: space-between;
}
.multiselect {
    width: 80%;

    @media screen and  (max-width: 990px) {
        width: 50%;
    }
}
</style>
